/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_ExpandInputs */



/**
* | output |
* | --- |
* | "Expand" |
*
* @param {Ui_ExpandInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ui_expand = /** @type {((inputs?: Ui_ExpandInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_ExpandInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Expand")
});